import styled from 'styled-components'

import { Color } from 'root-constants'

export const StyledToggle = {
  Wrapper: styled.label`
    position: relative;
    display: inline-block;
    width: 54px;
    height: 32px;
    cursor: pointer;
    user-select: none;

    input:checked + span {
      background-color: ${Color.GOLD_BASE};
    }

    input:checked + span::after {
      transform: translateX(22px);
    }
  `,
  Input: styled.input`
    position: absolute;
    width: 0;
    height: 0;
    opacity: 0;
  `,
  Toggle: styled.span`
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 34px;
    background: ${Color.GRAY_SECONDARY};
    transition: background-color 0.3s ease;

    &::after {
      content: '';
      position: absolute;
      top: 3px;
      left: 3px;
      width: 26px;
      height: 26px;
      border-radius: 50%;
      background: ${Color.WHITE};
      box-shadow:
        0 0 0 1px rgba(0, 0, 0, 0.04),
        0 3px 8px rgba(0, 0, 0, 0.15),
        0 3px 1px rgba(0, 0, 0, 0.06);
      transition: transform 0.3s ease;
    }
  `,
}
